import { Component } from '@angular/core';

@Component({
  selector: 'plantefeve-logo',
  imports: [],
  templateUrl: './plantefeve-logo.svg',
})
export class PlantefeveLogoComponent {}
